import store from "../../../store";
const sell = () => import('../views/sell.vue');
const howItWorksSell = () =>import('../views/howItWorksSell.vue');
const sellerSpace = () =>import('../views/sellerSpace.vue');
const SellSubmitted=()=>import('../views/SellSubmitted.vue');

//import { SWITCH_SELL_FORM } from "../store/actions";

export default [
    {
        path: "/sell",
        name: "sell",
        component: sell,
    }, 

    {
        path: "/sell/edit/:id",
        name: "sell-edit",
        component: sell,
    }, 

    {
        path: "/how-it-works-sell",
        name: "how-it-works-sell",
        component: howItWorksSell,
    }, 

    {
        path: "/seller-space",
        name: "seller-space",
        component: sellerSpace,
      
    }, 
    {
        path:'/sell-submitted/:id',
        name:'sellSubmitted',
        component: SellSubmitted,
    },
    

];